"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowCheckBoxEditor_1 = require("../../../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardRowButtonSet_1 = require("../../../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../../../shared/components/editors/CardRowSelectEditor");
var CardEditorContainer_1 = require("../../../../../../../../shared/components/containers/CardEditorContainer");
var CardRowNumericEditor_1 = require("../../../../../../../../shared/components/editors/CardRowNumericEditor");
var BrandAutoWithdrawEditor = /** @class */ (function (_super) {
    __extends(BrandAutoWithdrawEditor, _super);
    function BrandAutoWithdrawEditor(props) {
        return _super.call(this, props) || this;
    }
    BrandAutoWithdrawEditor.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AL = this.props.ListBonusLevelsAvail.Subscribe("*", function (id, data) {
            _this.setState({ avail_levels: data.data });
        });
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    app_currency_id: _item.app_currency_id,
                    app_currency_title: _item.app_currency_title,
                    is_control_withdraw_amount: _item.is_control_withdraw_amount,
                    max_withdraw_amount: _item.max_withdraw_amount,
                    is_control_player_level: _item.is_control_player_level,
                    min_withdraw_player_level_id: _item.min_withdraw_player_level_id,
                    min_withdraw_player_level_title: _item.min_withdraw_player_level_title,
                    is_control_inout_percent: _item.is_control_inout_percent,
                    max_inout_percent_x100: _item.max_inout_percent_x100,
                    is_locked: _item.is_locked,
                    avail_levels: []
                });
            }
        }
        else {
            this.setState({
                app_currency_id: 0,
                app_currency_title: "",
                is_control_withdraw_amount: false,
                max_withdraw_amount: 0,
                is_control_player_level: false,
                min_withdraw_player_level_id: 0,
                min_withdraw_player_level_title: "",
                is_control_inout_percent: false,
                max_inout_percent_x100: 0,
                is_locked: false,
                avail_levels: []
            });
        }
        this.doReSetRules();
        this.props.ListBonusLevelsAvail.LoadData(this.props.rootRecord.key);
    };
    BrandAutoWithdrawEditor.prototype.componentWillUnmount = function () {
        this.props.ListBonusLevelsAvail.UnSubscribe(this.SID_AL);
    };
    BrandAutoWithdrawEditor.prototype.doReSetRules = function () {
        this.setState({
            app_currency_rules: { isError: false },
            min_withdraw_player_level_rules: { isError: false },
        });
    };
    BrandAutoWithdrawEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if (this.props.record != null) {
            if ((this.state.app_currency_id <= 0) || (this.state.app_currency_title.length === 0)) {
                this.setState({ app_currency_rules: { isError: true, errorMessage: "Валюта не выбрана!" } });
                return false;
            }
        }
        if (this.state.is_control_player_level) {
            if ((this.state.min_withdraw_player_level_id <= 0) || (this.state.min_withdraw_player_level_title.length === 0)) {
                this.setState({ min_withdraw_player_level_rules: { isError: true, errorMessage: "Уровень не выбран!" } });
                return false;
            }
        }
        return true;
    };
    BrandAutoWithdrawEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                is_control_withdraw_amount: this.state.is_control_withdraw_amount,
                max_withdraw_amount: this.state.max_withdraw_amount,
                is_control_player_level: this.state.is_control_player_level,
                min_withdraw_player_level_id: this.state.min_withdraw_player_level_id,
                is_control_inout_percent: this.state.is_control_inout_percent,
                max_inout_percent_x100: this.state.max_inout_percent_x100,
                is_locked: this.state.is_locked,
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Автоматическая выплата бренда изменена!");
            });
        }
    };
    BrandAutoWithdrawEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                brand_id: this.props.rootRecord.key,
                app_currency_id: this.state.app_currency_id,
                is_control_withdraw_amount: this.state.is_control_withdraw_amount,
                max_withdraw_amount: this.state.max_withdraw_amount,
                is_control_player_level: this.state.is_control_player_level,
                min_withdraw_player_level_id: this.state.min_withdraw_player_level_id,
                is_control_inout_percent: this.state.is_control_inout_percent,
                max_inout_percent_x100: this.state.max_inout_percent_x100,
                is_locked: this.state.is_locked,
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Автоматическая выплата бренда добавлена!");
            });
        }
    };
    BrandAutoWithdrawEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    BrandAutoWithdrawEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Добавить автоматическую выплату бренда";
        }
        else {
            return "Изменить автоматическую выплату бренда";
        }
    };
    BrandAutoWithdrawEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 600 },
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Валюта автовыплаты:", placeholder: "Выберите валюту автовыплаты" }, value: { key: this.state.app_currency_id, value: this.state.app_currency_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        app_currency_id: newVal.key,
                        app_currency_title: newVal.value,
                        app_currency_rules: { isError: false }
                    });
                }, items: this.props.availCurrency, required: true, rules: this.state.app_currency_rules, disabled: this.props.record != null }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Контролировать сумму выплаты", value: this.state.is_control_withdraw_amount, onChecked: function (checked) { _this.setState({ is_control_withdraw_amount: checked }); } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Макс сумма выплаты", placeholder: "Введите максимальную сумму выплаты" }, values: { max: 999999, min: 0, value: this.state.max_withdraw_amount }, onValueChanged: function (newVal) {
                    _this.setState({
                        max_withdraw_amount: newVal
                    });
                }, disabled: !this.state.is_control_withdraw_amount }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Контролировать уровень игрока", value: this.state.is_control_player_level, onChecked: function (checked) { _this.setState({ is_control_player_level: checked }); } }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Уровень игрока:", placeholder: "Выберите уровень игрока" }, value: { key: this.state.min_withdraw_player_level_id, value: this.state.min_withdraw_player_level_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        min_withdraw_player_level_id: newVal.key,
                        min_withdraw_player_level_title: newVal.value,
                        min_withdraw_player_level_rules: { isError: false }
                    });
                }, items: this.state.avail_levels, required: true, rules: this.state.min_withdraw_player_level_rules, disabled: !this.state.is_control_player_level }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Контролировать макс инаут %", value: this.state.is_control_inout_percent, onChecked: function (checked) { _this.setState({ is_control_inout_percent: checked }); } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Макс инаут %", placeholder: "Введите максимальный процент ввода-вывода" }, values: { max: 999999, min: 1, value: this.state.max_inout_percent_x100 }, onValueChanged: function (newVal) {
                    _this.setState({
                        max_inout_percent_x100: newVal
                    });
                }, disabled: !this.state.is_control_inout_percent }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Заблокировать автовыплату", value: this.state.is_locked, onChecked: function (checked) { _this.setState({ is_locked: checked }); } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnNew: "Создать", btnGoBack: "Вернуться", btnEdit: "Сохранить" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return BrandAutoWithdrawEditor;
}(React.Component));
exports.default = BrandAutoWithdrawEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ui/component/options/auto_withdraws/BrandAutoWithdrawEditor.tsx
// module id = 1802
// module chunks = 0